import { render, staticRenderFns } from "./DelPlace.vue?vue&type=template&id=1b6af182"
import script from "./DelPlace.vue?vue&type=script&lang=js"
export * from "./DelPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports